module.exports = __webpack_public_path__ + "static/explanationImage-55141920013eed3ccd11a5bd9c7b37cf.png";